import { useEffect, useRef, DependencyList } from 'react';
import * as d3 from 'd3';

/**
 * This hook renders D3.js charts into react with
 * the provided function. Returns a ref which must be put
 * into the svg we want to render our chart in.
 * 
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

export const useD3 = (
  renderChartFn: (svg: any) => void, 
  dependencies: DependencyList | undefined
) => {
    const ref = useRef<SVGSVGElement>(null);
    useEffect(() => {
        renderChartFn(d3.select('#be_graph'));
        return () => {
          d3.selectAll("#be_graph > *").remove();
        };
    }, dependencies);
    return ref;
};